import React from "react";

const ParametersTabContent = ({
  initialData,
  isAllowToChangeSystemComponent,
  parameterGroups, // Pass parameterGroups as a prop
}) => {
  const data = initialData || {}; // Ensure data is an object

  return (
    <div className="overflow-y-auto h-64 pr-2">
      <fieldset disabled={isAllowToChangeSystemComponent}>
        <div className="space-y-6">
          {parameterGroups.map(({ group, fields }) => (
            <div
              key={group}
              className="border border-gray-200 p-4 rounded-lg"
            >
              <h3 className="text-md font-medium mb-3">Параметр {group}</h3>
              <div className="grid grid-cols-2 gap-4 mb-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Делитель
                  </label>
                  <input
                    type="number"
                    name={`${group}divisor`}
                    defaultValue={data[`${group}divisor`] || 0}
                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                {fields.map((field) => (
                  <div key={field}>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Значение {field}
                    </label>
                    <input
                      type="number"
                      name={`${group}_${field}`}
                      defaultValue={data[`${group}_${field}`] || 0}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </fieldset>
    </div>
  );
};

export default ParametersTabContent;